const POLL_INTERVAL_MS = 10000 // User activity and token freshness is polled every 10 seconds.
const REFRESH_THRESHOLD_SEC = 60 // Active users get their API tokens refreshed 1 minute before expiration
const ACTIVITY_TIMEOUT_MS = 900000 // User is declared inactive at 15 min without activity

export {
  POLL_INTERVAL_MS,
  REFRESH_THRESHOLD_SEC,
  ACTIVITY_TIMEOUT_MS
}
